import axios from 'axios'

const API_PATH = 'admins/fast_sell/images'

const FastSellImageApi = {
  /**
   * Get list of `Fast Sell Images`
   * @param {int} sellerId sellerId parameter
   * @return {object} Collection of `Fast Sell Images`
   */
  index: async ({ sellerId }) => {
    const params   = {
      seller_id   : sellerId,
      is_assigned : false
    }
    const response = axios.get(API_PATH, { params })
    return response
  },
  /**
   * Create a `Fast Sell Image`
   * @param {object} params uri parameter
   * @return {object} `Fast Sell Image` that has been created
   */
  create: async ({ formData }) => {
    const response = await axios.post(API_PATH, formData)
    return response
  },
  /**
   * Destroy a `Fast Sell Image`
   * @param {object} params uri parameter
   * @return {object} `Fast Sell Image` that   has been created
   */
  destroy: async ({ imageId }) => {
    const path     = `${API_PATH}/${imageId}`
    const response = axios.delete(path)
    return response
  }
}

export default FastSellImageApi
